import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import ReviewForm from "./ReviewForm";
import Footer from "./Footer";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/submit" element={<ReviewForm />} />
      </Routes>

      {/* Footer below all routes */}
      <Footer />
    </>
  );
}

export default App;
